import { keys } from 'lodash';
import { useFormContext } from 'react-hook-form';
import { ValidationProblemDetails } from 'src/services/api/api-client';

export function pascalToCamelCase(name: string) {
  return name.charAt(0).toLowerCase() + name.substr(1);
}

export const useHookFieldErrors = (dataKey: string): string | string[] | undefined => {
  const form = useFormContext();
  const getMultipleErrors = () => {
    if (!keys(form.formState.errors[dataKey]?.types).length) return undefined;
    return Object.values(form.formState.errors[dataKey]?.types ?? {});
  };

  return form.formState.errors[dataKey]?.message?.toString() ?? getMultipleErrors();
};

export const isValidationProblemDetails = (error: unknown): error is ValidationProblemDetails => {
  return error instanceof ValidationProblemDetails;
};
